import Box from '@mui/material/Box';
import { styled, Theme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import ColorIndicator from 'further-ui/components/ColorIndicator';
import { Column, Row } from 'further-ui/components/Layout';
import React from 'react';

const PaddedBox = styled(Box)<{ ownerState: { alignItems: string } }>(
  ({ theme, ownerState }) => ({
    padding: theme.spacing(theme.spacingSizes.xs),
    ...(ownerState.alignItems === 'flex-start' && {
      paddingTop: theme.spacing(theme.spacingSizes.xxs),
    }),
  }),
);

type Props = React.ComponentProps<typeof ColorIndicator> & {
  text: React.ReactNode;
  subtext?: React.ReactNode;
  spacing?: keyof Theme['spacingSizes'];
  alignItems?: 'flex-start' | 'center' | 'flex-end';
};

const ColorIndicatorWithText: React.FC<Props> = ({
  text,
  subtext,
  spacing = 'xs',
  alignItems = 'center',
  ...colorIndicatorProps
}) => {
  return (
    <Row alignItems={alignItems} spacing={spacing}>
      <PaddedBox ownerState={{ alignItems }}>
        <ColorIndicator {...colorIndicatorProps} />
      </PaddedBox>
      <Column>
        <Typography variant="inherit">{text}</Typography>
        {subtext ? <Typography variant="body2">{subtext}</Typography> : null}
      </Column>
    </Row>
  );
};

export default ColorIndicatorWithText;
